import { HttpHandler } from 'msw'

import { account } from './account'
import { auth } from './auth'
import { catalogue } from './catalogue'
import { general } from './general'
import { park } from './park'
import { settings } from './settings'
import { transactions } from './transactions'

export const handlers: HttpHandler[] = [
    ...account,
    ...auth,
    ...catalogue,
    ...general,
    ...park,
    ...settings,
    ...transactions,
]
